import ActivityConfig from '../ActivityConfig';
import ActivityElement from './ActivityElement';
import Lesson from '../Lesson';
import Tool from '../Tool';
import { ScheduledLessonTypeEnum } from '../ScheduledLesson';
import { Versionable } from '@/models/Model';

export default interface Activity extends Versionable {
  id: number;
  name: string;
  type?: ActivityBlockType;
  questions: ActivityElement[];
  content?: ActivityElement[];
  hasGrade?: boolean;
  author: number;
  inBank: boolean;
  isPublicInBank: boolean;
  grade?: number;
  isDone: boolean;
  isActive?: boolean;
  config?: ActivityConfig;
  lesson?: number[];
  tools: Tool[];
  tagsIds: number[];
}

export interface ActivityMeta {
  id: number;
  originCourse: string;
  lessonsCount: number;
}

export interface EmptyActivity {
  id: number;
  lesson: number[];
  name: string;
}

export interface EmptyActivityWithLesson extends EmptyActivity {
  lessonInfo: Lesson & { type?: ScheduledLessonTypeEnum; order?: number };
}

export enum ActivityBlockType {
  REGULAR = 'REGULAR',
  OPTIONAL = 'OPTIONAL',
  CONSOLIDATION = 'CONSOLIDATION',
}

export function implementsOfActivity(obj: any): obj is Activity {
  if (!obj) return false;
  return 'id' in obj && 'name' in obj && 'questions' in obj && 'status' in obj;
}
